import {createStore} from 'vuex'
import {readEntryToken} from '@/utils/entryToken'

const entryToken = readEntryToken(window.location.href);
if (entryToken) {
    localStorage.setItem('xfbm_access_token', entryToken);
    localStorage.removeItem('login_type');
    sessionStorage.removeItem('zlb_face_verified');
}

export default createStore({
    state: {
        user: {},
        env: 'h5',
        cachePages: [],
        askPaper: false,
        accessToken: localStorage.getItem('xfbm_access_token') || '',
        studyFilter: {
            selected : 0,
        }
    },
    getters: {},
    mutations: {
        setStudyFilter(state,f){
            state.studyFilter = f;
        },
        updateAccessToken(state, t) {
            state.accessToken = t;
            if (t) {
                localStorage.setItem('xfbm_access_token', t);
            } else {
                localStorage.removeItem('xfbm_access_token');
                localStorage.removeItem('login_type');
                sessionStorage.removeItem('zlb_face_verified');
            }
        },
        updateAskPaperState(state, val) {
            state.askPaper = val;
        },
        updateUser(state, val) {
            state.user = val;
        },
        updateEnv(state, e) {
            state.env = e;
        },
        setCachePage(state, page) {
            var index = state.cachePages.indexOf(page);
            if (index < 0) {
                state.cachePages.push(page);
            }
        },
        delCachePage(state, page) {
            var index = state.cachePages.indexOf(page);
            if (index > -1) {
                state.cachePages.splice(index, 1);
            }
        },
    },
    actions: {},
    modules: {}
})
